import { Select } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useDashboardFilters } from '@contexts'

import {
  MONTHLY_COMPLIANCE_STATUS_ORDER,
  normalizeMonthlyComplianceSelection,
} from '../monthlyComplianceStatus'
import { FilterGroup } from './styled'

const ComplianceStatusSelector = () => {
  const { t } = useTranslation()
  const { monthlyComplianceStatuses, setMonthlyComplianceStatuses } = useDashboardFilters()

  const options = useMemo(
    () =>
      MONTHLY_COMPLIANCE_STATUS_ORDER.map(value => ({
        value,
        label:
          value === 'CONFIRMED'
            ? t('admin_router.dashboard.compliance_confirmed')
            : value === 'TRANSIT'
            ? t('admin_router.dashboard.compliance_transit')
            : t('admin_router.dashboard.compliance_delivered'),
      })),
    [t],
  )

  return (
    <FilterGroup>
      <Select
        mode="multiple"
        allowClear
        style={{ minWidth: 260 }}
        placeholder={t('admin_router.dashboard.compliance_status')}
        aria-label={t('admin_router.dashboard.compliance_status')}
        options={options}
        value={monthlyComplianceStatuses}
        onChange={raw =>
          setMonthlyComplianceStatuses(
            normalizeMonthlyComplianceSelection(Array.isArray(raw) ? raw : []),
          )
        }
        maxTagCount="responsive"
      />
    </FilterGroup>
  )
}

export { ComplianceStatusSelector }
